import {
    SortParams,
} from 'app/types/common.types'

const defaultRateCardsSort: SortParams = {
    sortField: 'id',
    sortType: 'desc',
}

export default defaultRateCardsSort
